import React from "react";
import {ReactComponent as VisaLogo} from "../../images/visa-logo.svg";
import {ReactComponent as MasterCardLogo} from "../../images/mastercard-logo.svg";
import CreditCard from "@material-ui/icons/CreditCard";

const CreditCardPanel = ({paymentMethod={ id: '', type: '', brand: '', last4: '', expiry: '', name: ''}}) => {

    let cardLogo;
    switch (paymentMethod.brand.toLowerCase()) {
        case 'visa':
            cardLogo = <VisaLogo height={30} width={45}/>
            break;

        case 'mastercard':
            cardLogo = <MasterCardLogo height={30} width={45}/>
            break;

        default:
            cardLogo = <CreditCard fontSize="large" color="disabled"/>
    }

    return (
    <div className="p-3">
        <div className="mb-2">
            {cardLogo}
        </div>
        <div className="font-mono text-xl my-3">**** **** **** {paymentMethod.last4}</div>
        <div className="flex flex-row justify-between w-full mt-3 mb-1">
            <div className="font-mono text-sm">{paymentMethod.name}</div>
            <div className="font-mono text-sm"><span className="text-xs text-gray-400">Expiry</span> {paymentMethod.expiry}</div>
        </div>
    </div>
    )

}

export default CreditCardPanel